/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Cost_You_PayInputs */

const en_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You pay`)
};

const zh_hans1_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需支付`)
};

const pt_br2_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você paga`)
};

const es_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagas`)
};

const fr_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous payez`)
};

const de_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du zahlst`)
};

const ru_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы платите`)
};

const it_endpoint_cost_you_pay = /** @type {(inputs: Endpoint_Cost_You_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paghi`)
};

/**
* | output |
* | --- |
* | "You pay" |
*
* @param {Endpoint_Cost_You_PayInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_you_pay = /** @type {((inputs?: Endpoint_Cost_You_PayInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_You_PayInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_you_pay(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_you_pay(inputs)
	if (locale === "es") return es_endpoint_cost_you_pay(inputs)
	if (locale === "fr") return fr_endpoint_cost_you_pay(inputs)
	if (locale === "de") return de_endpoint_cost_you_pay(inputs)
	if (locale === "ru") return ru_endpoint_cost_you_pay(inputs)
	if (locale === "it") return it_endpoint_cost_you_pay(inputs)
	return en_endpoint_cost_you_pay(inputs)
});